import { RoleName } from '../types'

// an object with all permissions
export enum Permission {
  'side_menu' = 'side_menu',
  'change_salary' = 'change_salary',
  'approve_target' = 'approve_target',
  'set_bonus' = 'set_bonus',
  'view_salary' = 'view_salary',
  'schedule_meeting' = 'shedule_meeting',
}

export // rules describing what roles have what permissions
const rules = {
  [RoleName.GlobalAdmin]: [Permission.approve_target, Permission.change_salary],
  [RoleName.ClusterManager]: [Permission.side_menu, Permission.approve_target, Permission.change_salary, Permission.set_bonus],
  [RoleName.NetworkManager]: [Permission.side_menu, Permission.approve_target, Permission.change_salary, Permission.set_bonus],
  [RoleName.CompanyManager]: [
    Permission.side_menu,
    Permission.approve_target,
    Permission.change_salary,
    Permission.set_bonus,
    Permission.view_salary,
    Permission.schedule_meeting,
  ],
  [RoleName.BuManager]: [
    Permission.side_menu,
    Permission.approve_target,
    Permission.change_salary,
    Permission.set_bonus,
    Permission.view_salary,
    Permission.schedule_meeting,
  ],
  [RoleName.Replyer]: [Permission.side_menu, Permission.view_salary],
  [RoleName.Hr]: [Permission.view_salary],
  // TODO: remove this once we agree upon Roles at back end. Right now it is capital HR
  [RoleName.Hr.toUpperCase()]: [Permission.view_salary],
}
